import {
	estaAtrasadoParaFila,
	resolverChipStatusFila,
	temSituacaoFilaHoje,
} from "./gestaoVagaFilaUi.js"

export { resolverChipStatusFila }

/** Abas da tela Fila da vaga (layout) */
export const ABA_FILA_AGORA = "agora"
export const ABA_FILA_OUTROS = "outros"

/**
 * Classifica vaga para aba Agora / Outros.
 * @returns {'agora'|'outros'}
 */
export function classificarVagaFilaTab(v) {
	if (!v) return ABA_FILA_OUTROS
	if (v.naFila || v.podeEntrarFila || v.podeSairFila) {
		return ABA_FILA_AGORA
	}
	if (temSituacaoFilaHoje(v)) {
		return ABA_FILA_AGORA
	}
	return ABA_FILA_OUTROS
}

export function filtrarVagasPorAbaFila(vagas, aba) {
	const lista = Array.isArray(vagas) ? vagas : []
	return lista.filter((v) => classificarVagaFilaTab(v) === aba)
}

export function contarVagasPorAbaFila(vagas) {
	const lista = Array.isArray(vagas) ? vagas : []
	let agora = 0
	let outros = 0
	lista.forEach((v) => {
		if (classificarVagaFilaTab(v) === ABA_FILA_AGORA) agora += 1
		else outros += 1
	})
	return { agora, outros }
}

/** Ordem na aba Agora: na fila → atrasado (pode/não pode) → pode entrar → demais */
export function ordenarVagasFilaAgora(vagas) {
	return [...vagas].sort((a, b) => {
		const peso = (v) => {
			if (v.naFila) return 0
			if (estaAtrasadoParaFila(v) && v.podeEntrarFila) return 1
			if (estaAtrasadoParaFila(v)) return 2
			if (v.podeEntrarFila) return 3
			if (v.podeSairFila) return 4
			return 5
		}
		return peso(a) - peso(b)
	})
}

export function resolverAbaInicialFila({ vagas, idVagaDestaque, abaQuery }) {
	if (abaQuery === ABA_FILA_AGORA || abaQuery === ABA_FILA_OUTROS) {
		return abaQuery
	}
	if (idVagaDestaque > 0) {
		const alvo = (Array.isArray(vagas) ? vagas : []).find((v) => v.id === idVagaDestaque)
		if (alvo) return classificarVagaFilaTab(alvo)
	}
	const { agora } = contarVagasPorAbaFila(vagas)
	return agora > 0 ? ABA_FILA_AGORA : ABA_FILA_OUTROS
}

/** Mock para revisar layout: /app/gestaoVaga/fila?previewLayout=1 */
export const VAGAS_FILA_LAYOUT_MOCK = [
	{
		id: 9001,
		titulo: "Centro — Manhã",
		cidadeEstado: "São Paulo, SP",
		distanciaTexto: "1,2 km",
		logradouro: "Rua Exemplo",
		numero: "100",
		latitude: -23.55,
		longitude: -46.63,
		dataRefFormatada: "21/05/2026",
		jornadaHoje: true,
		diaHoje: "Quinta",
		horarioHoje: "08:00 – 12:00",
		naFila: true,
		posicaoFila: 2,
		totalNaFila: 5,
		entrouEm: "07:58",
		podeEntrarFila: false,
		podeSairFila: true,
		dentroRaioFila: true,
		motivo: "",
		motivoTipo: "na_fila",
		prazoFila: {
			inicioJornadaHora: "08:00",
			ingressoAteHora: "08:15",
			estaAtrasado: false,
			minutosAtraso: 0,
			minutosRestantes: 12,
			prazoEncerrado: false,
			toleranciaMin: 15,
		},
	},
	{
		id: 9002,
		titulo: "Zona Sul — Tarde",
		cidadeEstado: "São Paulo, SP",
		distanciaTexto: "850 m",
		raioFilaMetros: 300,
		latitude: -23.6,
		longitude: -46.64,
		dataRefFormatada: "21/05/2026",
		jornadaHoje: true,
		diaHoje: "Quinta",
		horarioHoje: "14:00 – 18:00",
		naFila: false,
		posicaoFila: 0,
		totalNaFila: 0,
		entrouEm: "",
		podeEntrarFila: false,
		podeSairFila: false,
		motivo: "Aproxime-se da vaga para entrar na fila (você está a 850 m).",
		motivoTipo: "fora_raio",
		prazoFila: {
			inicioJornadaHora: "14:00",
			ingressoAteHora: "14:20",
			estaAtrasado: true,
			minutosAtraso: 8,
			minutosRestantes: 12,
			prazoEncerrado: false,
			toleranciaMin: 20,
		},
	},
	{
		id: 9005,
		titulo: "Oeste — Tarde (atrasado)",
		cidadeEstado: "São Paulo, SP",
		distanciaTexto: "200 m",
		dataRefFormatada: "21/05/2026",
		jornadaHoje: true,
		diaHoje: "Quinta",
		horarioHoje: "13:00 – 17:00",
		naFila: false,
		podeEntrarFila: true,
		podeSairFila: false,
		dentroRaioFila: true,
		motivo: "",
		motivoTipo: "atrasado",
		prazoFila: {
			inicioJornadaHora: "13:00",
			ingressoAteHora: "13:30",
			estaAtrasado: true,
			minutosAtraso: 22,
			minutosRestantes: 8,
			prazoEncerrado: false,
			toleranciaMin: 30,
		},
	},
	{
		id: 9003,
		titulo: "Leste — Noite",
		cidadeEstado: "São Paulo, SP",
		distanciaTexto: "5,1 km",
		dataRefFormatada: "21/05/2026",
		jornadaHoje: true,
		diaHoje: "Quinta",
		horarioHoje: "19:00 – 23:00",
		naFila: false,
		podeEntrarFila: false,
		podeSairFila: false,
		motivo: "O ingresso na fila abre às 18:40. Aguarde o horário.",
		motivoTipo: "aguardando",
		prazoFila: {
			inicioJornadaHora: "19:00",
			ingressoAteHora: "19:00",
			estaAtrasado: false,
			minutosRestantes: null,
			prazoEncerrado: false,
			toleranciaMin: 0,
		},
	},
	{
		id: 9004,
		titulo: "Norte — Sábado",
		cidadeEstado: "Guarulhos, SP",
		distanciaTexto: "12 km",
		dataRefFormatada: "21/05/2026",
		jornadaHoje: false,
		diaHoje: "",
		horarioHoje: "",
		naFila: false,
		podeEntrarFila: false,
		podeSairFila: false,
		motivo: "Sem jornada hoje. Sua próxima jornada é no sábado.",
	},
]

/** Mock do detalhe (previewLayout) — grade de dias e titularidade */
export const VAGA_DETALHE_FILA_MOCK = {
	id: 9001,
	titulo: "Centro — Manhã",
	cidadeEstado: "São Paulo, SP",
	distanciaTexto: "1,2 km",
	mensagem: {
		descricao: "Vaga de entregas no centro. Veja abaixo em quais dias você já é titular.",
		horariosLinhas: [
			{
				diaSemana: 4,
				diaId: "qui",
				diaNome: "Quinta-feira",
				diaAbrev: "Qui",
				texto: "08:00 – 12:00 · Piso: R$ 80",
				slotIngresso: {
					diaId: "qui",
					data: "2026-05-21",
					dataFormatada: "21/05/2026",
					diaNome: "Quinta-feira",
					jaInscrito: true,
					podeIngressar: false,
					titularesNoDia: 2,
					limitePorDia: 3,
				},
			},
			{
				diaSemana: 5,
				diaId: "sex",
				diaNome: "Sexta-feira",
				diaAbrev: "Sex",
				texto: "08:00 – 12:00",
				slotIngresso: {
					diaId: "sex",
					data: "2026-05-22",
					dataFormatada: "22/05/2026",
					diaNome: "Sexta-feira",
					jaInscrito: false,
					podeIngressar: true,
					titularesNoDia: 1,
					limitePorDia: 3,
					vagasRestantes: 2,
				},
			},
			{
				diaSemana: 6,
				diaId: "sab",
				diaNome: "Sábado",
				diaAbrev: "Sáb",
				texto: "09:00 – 13:00",
				slotIngresso: {
					diaId: "sab",
					data: "2026-05-24",
					dataFormatada: "24/05/2026",
					diaNome: "Sábado",
					jaInscrito: false,
					podeIngressar: false,
					aguardandoJanela: true,
					dataInicioIngressoFormatada: "23/05/2026",
				},
			},
		],
	},
}
